import { defaultCanvasFilter } from '@/schema/page-config'

export const canvasFilterControls = [
  { key: 'hue', label: '色相', min: -180, max: 180 },
  { key: 'saturation', label: '饱和度', min: -100, max: 100 },
  { key: 'brightness', label: '明度', min: -100, max: 100 },
  { key: 'contrast', label: '对比度', min: -100, max: 100 },
  { key: 'opacity', label: '不透明度', min: 0, max: 100 },
  { key: 'grayscale', label: '灰度', min: 0, max: 100 }
]

export function canvasFilterValue (key, input) {
  const control = canvasFilterControls.find(control => control.key === key)
  if (!control || input === null || typeof input === 'boolean' || !['number', 'string'].includes(typeof input) || (typeof input === 'string' && !input.trim())) return null
  const value = Number(input)
  return Number.isFinite(value) ? Math.min(control.max, Math.max(control.min, Math.round(value))) : null
}

export function normalizedCanvasFilter (filter) {
  const result = { ...defaultCanvasFilter }
  canvasFilterControls.forEach(({ key }) => {
    const value = filter && canvasFilterValue(key, filter[key])
    if (value !== null && value !== undefined) result[key] = value
  })
  return result
}

export function canvasFilterContext (contain) {
  return { id: contain.id, recordId: contain.projectRecord && contain.projectRecord.id, generation: contain.editorSaveGeneration,
    project: contain.pageProject, pageId: contain.activePageId, pageContext: contain._pageTemplateContext, config: contain.config }
}

export function currentCanvasFilterContext (contain, context) {
  return Boolean(context && contain.projectRecord && contain.editorSaveReady && !contain.editorVersionSwitching &&
    context.id === contain.id && context.recordId === contain.projectRecord.id && context.generation === contain.editorSaveGeneration &&
    context.project === contain.pageProject && context.pageId === contain.activePageId && context.pageContext === contain._pageTemplateContext && context.config === contain.config)
}

// 一次滑动或连续键盘输入只在起止处收录历史，避免250ms防抖把一次操作切成多步。
export function createCanvasFilterGesture (contain) {
  let context = null, token = null
  const end = () => {
    if (!token) return false
    const valid = currentCanvasFilterContext(contain, context)
    if (contain._editorFilterGesture === token) contain._editorFilterGesture = null
    context = null; token = null
    if (valid) contain.rememberStructure()
    return valid
  }
  const begin = () => {
    if (token) { if (currentCanvasFilterContext(contain, context)) return true; end(); return false }
    const next = canvasFilterContext(contain)
    if (!currentCanvasFilterContext(contain, next) || contain._editorFilterGesture) return false
    contain.rememberStructure()
    context = next; token = {}
    contain._editorFilterGesture = token
    return true
  }
  const apply = next => {
    if (!begin()) return false
    const previous = normalizedCanvasFilter(context.config.filter)
    if (canvasFilterControls.every(({ key }) => previous[key] === next[key])) return false
    contain.$set(context.config, 'filter', next)
    return true
  }
  return {
    begin, end,
    update (key, input) {
      const value = canvasFilterValue(key, input)
      if (value === null) return false
      if (token && !currentCanvasFilterContext(contain, context)) { end(); return false }
      return apply({ ...normalizedCanvasFilter(contain.config.filter), [key]: value })
    },
    reset () { end(); const changed = apply({ ...defaultCanvasFilter }); end(); return changed },
    get active () { return Boolean(token) }
  }
}
